import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { translationsDic } from '../translations';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  public languages = ['sr', 'en'];

  public language = 'sr';

  public image = '../../../assets/images/en.png';

  private translations = translationsDic;
  private currentLangSubject: BehaviorSubject<string>;
  public currentLang: Observable<string>;

  constructor() {
    this.currentLangSubject = new BehaviorSubject<string>(this.language);
    this.currentLang = this.currentLangSubject.asObservable();
  }

  translate(key: string): string {
    if (this.translations[this.language] != null) {
      if (this.translations[this.language].values[key] != null) {
        return this.translations[this.language].values[key];
      }
    }
    return key;
  }

  changeLang() {
    if (this.language === 'sr') {
      this.language = 'en';
      this.image = '../../../assets/images/sr.png';
    } else {
      this.language = 'sr';
      this.image = '../../../assets/images/en.png';
    }
    this.currentLangSubject.next(this.language);
  }
}

export class TranslationSet {
  public languange: string;
  public values: { [key: string]: string } = {};
}
